import React from 'react';
import Logo from './Logo';
import QRCode from './QRCode';
import Copyright from './Copyright';
import { useTranslation } from '../../hooks/useTranslation';
import { Link } from 'react-router-dom';
import { EXTERNAL_LINKS } from '../../constants/links';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="w-full bg-gradient-to-b from-[#0f172a] to-[#020617] relative overflow-hidden">
      <div className="container mx-auto px-6 py-16">
        {/* 主内容区 - 分为左中右三部分 */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10 lg:gap-10">
          
          {/* 左侧 - 品牌信息 */}
          <div className="flex-1 lg:max-w-md">
            <div className="flex items-center gap-4 mb-6">
              {/* Logo */}
              <img
                src="/logo.png"
                alt="DecisionAI"
                className="w-12 h-12 object-contain"
              />
              {/* 品牌名称 */}
              <h2 className="text-3xl font-semibold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent uppercase tracking-wider">
                DECISIONAI
              </h2>
            </div>
            <p className="text-gray-400 text-base leading-relaxed">
              {t('footer.companyInfo')}
            </p>
          </div>
          
          {/* 中间 - 导航链接 */}
          <div className="flex flex-col sm:flex-row gap-8 lg:gap-16">
            {/* 产品 */}
            <div>
              <h3 className="text-gray-300 text-sm font-medium mb-4 uppercase tracking-wider">
                {t('nav.product')}
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/product" className="text-gray-400 hover:text-white text-sm transition-colors">
                    {t('footer.coreFeatures')}
                  </Link>
                </li>
                <li>
                  <Link to="/demo" className="text-gray-400 hover:text-white text-sm transition-colors">
                    {t('nav.demo')}
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* 解决方案 */}
            <div>
              <h3 className="text-gray-300 text-sm font-medium mb-4 uppercase tracking-wider">
                {t('nav.solutions')}
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/solutions" className="text-gray-400 hover:text-white text-sm transition-colors">
                    {t('footer.industrySolutions')}
                  </Link>
                </li>
                <li>
                  <Link to="/cases" className="text-gray-400 hover:text-white text-sm transition-colors">
                    {t('nav.cases')}
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* 联系我们 */}
            <div>
              <h3 className="text-gray-300 text-sm font-medium mb-4 uppercase tracking-wider">
                {t('footer.contactUs')}
              </h3>
              <ul className="space-y-3">
                <li className="text-gray-400 text-sm">
                  {t('footer.phone')}
                </li>
                <li className="text-gray-400 text-sm">
                  contact@decisionai.com
                </li>
              </ul>
            </div>
          </div>
          
          {/* 右侧 - CTA和二维码 */}
          <div className="flex flex-col items-center">
            <button 
              onClick={() => window.open(EXTERNAL_LINKS.DEMO_FORM, '_blank')}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white font-medium rounded-full transition-all duration-200 shadow-lg hover:shadow-xl mb-4"
            >
              {t('nav.freeTrial')}
            </button>
            <QRCode />
          </div>
        </div>
        
        {/* 分割线 */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          {/* 底部信息 - 地址和版权 */}
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 text-gray-500 text-xs">
            <div className="text-center lg:text-left">
              北京市朝阳区阜通东大街1号院望京SOHO塔2 A座2405
            </div>
            <Copyright />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;